import http from '@/utils/http';
const base_path = '/v2/plan/config';

/**
 * 获取计划配置接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getPlanConfigApi = (params) => {
  return http.get({
    url: base_path,
    params,
  });
};
